import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const awrContract = c.router({
  lookup: {
    method: 'POST',
    path: '/awr/accounts/lookup',
    body: z.object({
      _id: z.string().optional(),
      hostName: z.string().optional(),
      accountName: z.string().optional(),
      countryIso: z.string().optional(),
    }),
    responses: { 200: z.object({ account: z.any() }) },
  },
});
